export enum TrackingEventCategory {
  MainFlightForm = 'main_flight_form',
  MainMobileFlightForm = 'main_mobile_flight_form',
  GeneralFlightForm = 'general_flight_form',
  PrivateJetsForm = 'private_jets_form',
  CorporateForm = 'corporate_form',
  ContactUsForm = 'contact_us_form',
  CallBackForm = 'call_back_form'
}
